import { render, staticRenderFns } from "./ScwlWaybillScrollBoard.vue?vue&type=template&id=7682ca7e"
import script from "./ScwlWaybillScrollBoard.vue?vue&type=script&lang=js"
export * from "./ScwlWaybillScrollBoard.vue?vue&type=script&lang=js"
import style0 from "./ScwlWaybillScrollBoard.vue?vue&type=style&index=0&id=7682ca7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports